import React from 'react'
import { Box, BoxProps } from 'rebass/styled-components'
import styles from './NavGroup.module.css'

export interface GroupContentProps extends BoxProps {
  labelId: string
  isExpanded?: boolean
}

export const GroupContent = ({ children, labelId, isExpanded = true }: GroupContentProps): JSX.Element => {
  return (
    <Box
      data-name="GroupContent"
      id={`${labelId}-content`}
      className={`${styles.groupContent} ${isExpanded ? styles.expanded : styles.collapsed}`}
    >
      {children}
    </Box>
  )
}
